import { Action } from 'redux'
import { CalendarFiltersActions } from '../../../reducers/bookingCalendar/actionNames'

export const filterByPlace = (
  data: Pick<
    IFilterCalendarByPlace,
    Exclude<keyof IFilterCalendarByPlace, 'type'>
  >,
): IFilterCalendarByPlace => ({
  ...data,
  type: CalendarFiltersActions.FilterByPlace,
})

export interface IFilterCalendarByPlace
  extends Action<CalendarFiltersActions.FilterByPlace> {
  persons?: number
  name?: string
}
